import React, { useState } from "react";
import { PAYMENT_STATUS } from "../utils/paymentStatus";

const Tile = ({ tile, active, count, meta, onClick }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: "pointer",
        background: active ? "var(--vz-light)" : "#fff",
        padding: "15px 18px",
        transition: "background 0.15s ease",
        ...(hovered && !active ? { background: "var(--vz-light)" } : {}),
      }}
    >
      <div
        className="text-uppercase text-muted"
        style={{ fontSize: 11.5, fontWeight: 600, letterSpacing: 0.6 }}
      >
        {tile.label}
      </div>
      <div
        style={{
          fontSize: 22,
          fontWeight: 650,
          marginTop: 5,
          color: tile.fg || "inherit",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {count}
      </div>
      {meta && (
        <div className="text-muted" style={{ fontSize: 12.5, marginTop: 2 }}>
          {meta}
        </div>
      )}
    </div>
  );
};

/**
 * 4-tile summary row. Counts come from GET /clients/stats/, scoped to the
 * buyer_type toggle ONLY — never narrowed by search/payment_status/phase/
 * linked, and never by whichever tile is currently selected (this is a
 * deliberate difference from the Contracts List's own stats, which do
 * respect search/phase/year — see the Clients List Redesign plan).
 * Clicking "Overdue"/"Due in 30 days" toggles the payment_status filter;
 * clicking "Linked clients" toggles the linked filter.
 */
const ClientStatTiles = ({ stats, kindLabel, paymentStatus, linked, onSelectStatus, onSelectLinked }) => {
  const fmt = (v) => `€${(Number(v) || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

  const tiles = [
    {
      key: "all",
      label: kindLabel,
      count: stats?.all?.count ?? 0,
      meta: "in this view",
      active: !paymentStatus && !linked,
      onClick: () => {
        onSelectStatus("");
        onSelectLinked(false);
      },
    },
    {
      key: PAYMENT_STATUS.OVERDUE,
      label: "Overdue",
      fg: "var(--vz-danger)",
      count: stats?.overdue?.count ?? 0,
      meta: `${fmt(stats?.overdue?.amount_eur)} late`,
      active: paymentStatus === PAYMENT_STATUS.OVERDUE,
      onClick: () => onSelectStatus(paymentStatus === PAYMENT_STATUS.OVERDUE ? "" : PAYMENT_STATUS.OVERDUE),
    },
    {
      key: PAYMENT_STATUS.DUE_SOON,
      label: "Due in 30 days",
      fg: "var(--vz-warning)",
      count: stats?.due_soon?.count ?? 0,
      meta: "payments approaching",
      active: paymentStatus === PAYMENT_STATUS.DUE_SOON,
      onClick: () => onSelectStatus(paymentStatus === PAYMENT_STATUS.DUE_SOON ? "" : PAYMENT_STATUS.DUE_SOON),
    },
    {
      key: "linked",
      label: "Linked clients",
      count: stats?.linked?.count ?? 0,
      meta: "with a secondary party",
      active: linked,
      onClick: () => onSelectLinked(!linked),
    },
  ];

  return (
    <div
      className="border rounded-4 mb-3"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(148px, 1fr))",
        gap: 1,
        background: "var(--vz-border-color)",
        overflow: "hidden",
      }}
    >
      {tiles.map((tile) => (
        <Tile key={tile.key} tile={tile} active={tile.active} count={tile.count} meta={tile.meta} onClick={tile.onClick} />
      ))}
    </div>
  );
};

export default ClientStatTiles;
